<template>
  <el-aside
    :width="isCollapsed ? '64px' : '280px'"
    class="flex flex-col h-full bg-[var(--el-bg-color-page)] border-r border-r-th-border-light"
  >
    <navigation :collapsed="isCollapsed" />
    <el-footer
      class="flex flex-row justify-end items-center pt-4 pb-6 h-auto border-0"
      :class="{
        'px-0': isCollapsed,
        'px-4': !isCollapsed,
        'justify-around': isCollapsed
      }"
    >
      <el-button
        class="shrink-0"
        size="default"
        text
        :icon="isCollapsed ? ArrowRightIcon : ArrowLeftIcon"
        @click="handleCollapse"
      />
    </el-footer>
  </el-aside>
</template>
<script>
import Navigation from '@shared/components/sidebar/navigation.vue'
import debounce from 'debounce'
import { useAppConfigStore } from '@shared/store/app-config'
import { storeToRefs } from 'pinia'
import { isUnifiedCommerce } from '@shared/constants'
import { ArrowLeftIcon, ArrowRightIcon } from '@shared/assets/icons'

export default {
  components: {
    Navigation
  },
  props: {},
  setup() {
    const appConfigStore = useAppConfigStore()
    const { isSidebarCollapsed: isCollapsed } = storeToRefs(appConfigStore)
    const { toggleSidebar } = appConfigStore

    return { isCollapsed, toggleSidebar }
  },
  data() {
    return {
      userSelfCollapsedSidebar: false,
      ArrowLeftIcon,
      ArrowRightIcon
    }
  },
  computed: {
    isWhiteLabel() {
      return isUnifiedCommerce()
    }
  },
  mounted() {
    this.isCollapsed = false
    this.shouldToggleSidebar()
    window.addEventListener('resize', this.shouldToggleSidebar)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.shouldToggleSidebar)
  },
  methods: {
    handleCollapse() {
      this.toggleSidebar()
      this.userSelfCollapsedSidebar = this.isCollapsed
    },
    shouldToggleSidebar: debounce(function () {
      const windowWidth = window.innerWidth
      if (this.isCollapsed === false && windowWidth <= 1100) {
        this.isCollapsed = true
        this.userSelfCollapsedSidebar = false
      } else if (
        this.isCollapsed === true &&
        this.userSelfCollapsedSidebar === false &&
        windowWidth > 1100
      ) {
        // Automitically uncollapse only if user didn't collapse the sidebar by themselves
        this.isCollapsed = false
      }
    }, 100)
  }
}
</script>
